/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Automation_BadgeInputs */

const en_case_history_automation_badge = /** @type {(inputs: Case_History_Automation_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation`)
};

const pt_br2_case_history_automation_badge = /** @type {(inputs: Case_History_Automation_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automação`)
};

/**
* | output |
* | --- |
* | "Automation" |
*
* @param {Case_History_Automation_BadgeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_automation_badge = /** @type {((inputs?: Case_History_Automation_BadgeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Automation_BadgeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_automation_badge(inputs)
	return pt_br2_case_history_automation_badge(inputs)
});